import React, { useEffect, useState } from "react";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import { useNavigate } from "react-router-dom";

export default function DashboardDownloadsDetails() {
  const path = "Assets/scss/download.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();

  return (
    <div className="download-details col-lg-11 mx-auto">
      <p className="breadcrumbs">
        <a onClick={() => navigate(`/${lan}/searchall`)}>Home &gt; </a> Job
        details
      </p>
      <div className="col-lg-10 mx-auto">
        <div className="download-second">
          <div className="filter-detail">
            <div className="filter-detail-first col-md-7">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/expert-1.svg`}
                className="profile-img"
                alt=""
              />
              <div>
                <h5>Mohammed Shibu </h5>
                <h6>Sr. UX designer@ bypass technologies</h6>
                <div className="proposal">
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/location.svg`}
                      alt=""
                    />
                    Location: Riyadh
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/year-box.svg`}
                      alt=""
                    />
                    5 years
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/dollar-1.svg`}
                      alt=""
                    />
                    15-20k
                  </p>
                </div>
              </div>
            </div>
            <button className="buttons background-button">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/download-1.svg`}
                alt=""
              />
              Re- Download CV
            </button>
          </div>
          <div className="col-md-11 p-0">
            <div className="download-job">
              <h6>Job title</h6>
              <div className="job-p">
                <p>Sr. UX designer</p>
              </div>
            </div>
            <div className="download-job">
              <h6>About expert</h6>
              <div className="job-p">
                <p>
                  Dynamic professional with five years of experience in Riyadh,
                  Saudi Arabia, specializing in technology solutions at Bypass
                  Tech. Demonstrated expertise in [mention specific areas of
                  expertise or achievements relevant to the position you're
                  applying for]. Proven track record of [mention any notable
                  achievements or responsibilities held during your tenure at
                  Bypass Tech]. Strong communication and problem-solving skills,
                  with a passion for driving innovation and delivering results
                  in a fast-paced environment.
                </p>
              </div>
            </div>
            <div className="download-job">
              <h6>Known language</h6>
              <div className="job-p">
                <p>English - Fluent</p>
                <p>Arabic - Fluent</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <div className="download-job">
                  <h6>County</h6>
                  <div className="job-p">
                    <p>Saudi Arabia</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="download-job">
                  <h6>City</h6>
                  <div className="job-p">
                    <p> Riyadh</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="download-job">
              <h6>Academic info</h6>
              <div className="job-p">
                <p>MBA - University of Hunnah</p>
                <p>2012-2016</p>
              </div>
            </div>
            <div className="download-job">
              <h6>Employment</h6>
              <div className="job-p">
                <p>Sr. UX designer</p>
                <p>Google - 2019-2024</p>
                <p>Sr. UX designer</p>
                <p>Google - 2019-2024</p>
              </div>
            </div>
            <div className="download-job">
              <h6>Competencies and expertise</h6>
              <div className="add-skills">
                <p>
                  App design <span>+</span>
                </p>
                <p>
                  App design <span>+</span>
                </p>
                <p>
                  App design <span>+</span>
                </p>
                <p>
                  App design <span>+</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="similar-head">
          <h6>Similar posts</h6>
          <button className="buttons border-button">View all</button>
        </div>
        <div className=" bottom-section">
          <div className="filter-detail">
            <div className="filter-detail-first col-md-7">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/expert-1.svg`}
                className="profile-img"
                alt=""
              />
              <div>
                <h5>Mohammed Shibu </h5>
                <h6>Sr. UX designer@ bypass technologies</h6>
                <p>
                  Dynamic professional with five years of experience in Riyadh,
                  Saudi Arabia, specializing in technology solutions at Bypass
                  Tech. Demonstrated expertise in photoshop, figma...
                </p>
                <div className="proposal">
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/location.svg`}
                      alt=""
                    />
                    Location: Riyadh
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/year-box.svg`}
                      alt=""
                    />
                    5 years
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/dollar-1.svg`}
                      alt=""
                    />
                    15-20k
                  </p>
                </div>
                <div className="photoshop">
                  <p>Website design</p>
                  <p>Graphic design</p>
                  <p>Interaction</p>
                </div>
              </div>
            </div>
            <button className="buttons border-button">View details</button>
          </div>
          <div className="filter-detail">
            <div className="filter-detail-first col-md-7">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/expert-1.svg`}
                className="profile-img"
                alt=""
              />
              <div>
                <h5>Mohammed Shibu </h5>
                <h6>Sr. UX designer@ bypass technologies</h6>
                <p>
                  Dynamic professional with five years of experience in Riyadh,
                  Saudi Arabia, specializing in technology solutions at Bypass
                  Tech. Demonstrated expertise in photoshop, figma...
                </p>
                <div className="proposal">
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/location.svg`}
                      alt=""
                    />
                    Location: Riyadh
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/year-box.svg`}
                      alt=""
                    />
                    5 years
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/dollar-1.svg`}
                      alt=""
                    />
                    15-20k
                  </p>
                </div>
                <div className="photoshop">
                  <p>Website design</p>
                  <p>Graphic design</p>
                  <p>Interaction</p>
                </div>
              </div>
            </div>
            <button className="buttons border-button">View details</button>
          </div>
          <div className="filter-detail">
            <div className="filter-detail-first col-md-7">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/expert-1.svg`}
                className="profile-img"
                alt=""
              />
              <div>
                <h5>Mohammed Shibu </h5>
                <h6>Sr. UX designer@ bypass technologies</h6>
                <p>
                  Dynamic professional with five years of experience in Riyadh,
                  Saudi Arabia, specializing in technology solutions at Bypass
                  Tech. Demonstrated expertise in photoshop, figma...
                </p>
                <div className="proposal">
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/location.svg`}
                      alt=""
                    />
                    Location: Riyadh
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/year-box.svg`}
                      alt=""
                    />
                    5 years
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/dollar-1.svg`}
                      alt=""
                    />
                    15-20k
                  </p>
                </div>
                <div className="photoshop">
                  <p>Website design</p>
                  <p>Graphic design</p>
                  <p>Interaction</p>
                </div>
              </div>
            </div>
            <button className="buttons border-button">View details</button>
          </div>
        </div>
      </div>
    </div>
  );
}
